import React from 'react';

export const ChartLoading = () => (
  <svg viewBox="0 0 343 91" className="chart-loading">
    <defs>
      <path
        id="c"
        d="M.272 63.536s1.023.05 3-.536c4.09-1.213 11.699-4.18 18.803-9.16 3.533-2.476 7.33-6.084 10.437-9.484 12.375-13.538 27.29-8.639 42.956 2.18 15.666 10.818 31.221 9.052 41.143-6.404 9.922-15.455 23.087-17.969 37.187-13.848 14.099 4.122 26.441 12.764 37.974 5.216 11.532-7.548 14.597-11.998 28-12 13.403-.002 20 14.5 37 14.5s21.5-17.5 41-17.5 14.5-16.5 45.5-16.5"
      />
      <filter width="106.1%" height="132.9%" x="-3.1%" y="-14.9%" filterUnits="objectBoundingBox">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.96" result="shadowSpreadOuter1" />
        <feOffset dy="1" in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
        <feMorphology in="SourceAlpha" radius="1" result="shadowInner" />
        <feOffset dy="1" in="shadowInner" result="shadowInner" />
        <feComposite in="shadowOffsetOuter1" in2="shadowInner" operator="out" result="shadowOffsetOuter1" />
        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="3" />
        <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.43 0" />
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <path
        fill="#161616"
        d="M.272 63.5c.544-1.602 3.834-.732 9.055-2.685 7.237-2.707 17.136-7.76 23.185-16.46 10.414-14.977 28.117-8.263 43.737 2.583 9.345 6.488 23.952 9.715 31.023 4.028 4.748-3.818 6.026-4.628 10-10.852 9.893-15.493 23.02-17.969 37.078-13.837 14.058 4.131 33.023 11.492 39.571 4.25 6.549-7.241 16.437-11.027 25.81-11.027 9.371 0 20.527 14.5 37.04 14.5 16.515 0 17.5-17.5 41-17.5S312.32 0 343.272 0v87.5h-343s-.543-22.398 0-24z"
        transform="translate(0 4)"
      />
      <g transform="translate(0 4)">
        <use fill="#000" filter="url(#b)" xlinkHref="#c" />
        <use stroke="#888" strokeWidth="1.92" xlinkHref="#c" />
      </g>
    </g>
  </svg>
);
